module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/page-2.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/page-2.json
// module chunks = 135728916539164